import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Shiver, OnInk } from "../components/Characters";
import { api, errorText } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", location.pathname);
    api.post("/auth/session", { session_id: sessionId })
      .then((res) => { setUser(res.data); navigate("/account", { replace: true }); })
      .catch((err) => setError(errorText(err)));
  }, [location, navigate, setUser]);

  if (!error) return <div className="min-h-screen bg-ink" />;
  return (
    <div data-testid="auth-error" className="grid min-h-screen place-items-center bg-ink px-6 text-center text-paper">
      <div className="flex flex-col items-center">
        <OnInk className="h-28 w-28 bg-white/10"><Shiver className="w-[66%]" /></OnInk>
        <p className="mt-6 max-w-sm font-head text-2xl">{error}</p>
        <a href="/login" data-testid="auth-error-login-link" className="link-underline mt-6 font-body text-lg font-semibold">Try again</a>
      </div>
    </div>
  );
}
